export const assessmentTemplate = [
  {
    _id: "0009",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "Mmigliuri",
      createdDate: "2022-03-015T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "singleLegStance",
      omniTypeVersion: 1,
      title: "The Single-Leg Stance Test",
      purpose: "Cognitive Function",
      description: "A measure of the ability to stand on one leg and maintain balance.",
      duration: "About 5 minutes",
      directions:
        "To prepare for the one-leg stance test, please have the patient move into a corner and place a chair in front of them.  They should have their shoes off for the most accurate results. The patient may balance using any method they like as long as they are on one leg and the other leg is unsupported. You will start the timer when the patient's foot lifts off the floor, and end the timer when their foot touches the ground, their hands come off their hips,  they move their standing foot, or they touch their opposite foot braces against their standing leg.",
      attribution:
        "Reference: Timed single leg stance (SLS) has been correlated with amplitude and speed of sway in people without disease (Billek, 1990).",
      validated: "true",
      selfAssessment: false,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "sls1",
          numberText: "1",
          text: "Start time for right leg test",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Click start below once the patient lifts their left foot off the floor and balances on their right foot.",
          answerOptions: [
            {
              value: "start",
              text: "Start",
              displayType: "timer",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "sls2",
          numberText: "2",
          text: "Stop time for right leg test",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Click stop below once the patient's left foot touches the floor, braces against their other foot, or the patient loses balance.",
          answerOptions: [
            {
              value: "stop",
              text: "Stop",
              displayType: "timer",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "sls3",
          numberText: "1",
          text: "Start time for left leg test",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Click start below once the patient lifts their right foot off the floor and balances on their left foot.",
          answerOptions: [
            {
              value: "start",
              text: "Start",
              displayType: "timer",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "sls4",
          numberText: "2",
          text: "Stop time for left leg",
          subText: "",
          helpText: "",
          displayType: "button",
          multiSelectText: "false",
          instructions:
            "Click stop below once the patient's right foot touches the floor, braces against their other foot, or the patient loses balance.",
          answerOptions: [
            {
              value: "stop",
              text: "Stop",
              displayType: "timer",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
        rightLegResult: null,
        leftLegResult: null,
      },
      // assessmentResults: [
      //   {
      //     scoreTitle: "rightLegResult",
      //     scoreMin: "0",
      //     scoreMax: "20",
      //     finalResult: null,
      //     multiSelectText: "false",
      //     isDefault: false,
      //     algorithm: [
      //       {
      //         operation: "subtract",
      //         values: [
      //           "sls2.answerDate",
      //           "sls1.answerDate",
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     scoreTitle: "leftLegResult",
      //     scoreMin: "0",
      //     scoreMax: "20",
      //     finalResult: null,
      //     multiSelectText: "false",
      //     isDefault: false,
      //     algorithm: [
      //       {
      //         operation: "subtract",
      //         values: [
      //           "sls4.answerDate",
      //           "sls3.answerDate",
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     scoreTitle: "bothLegResult",
      //     scoreMin: "0",
      //     scoreMax: "20",
      //     finalResult: null,
      //     multiSelectText: "false",
      //     isDefault: true,
      //     algorithm: [
      //       {
      //         operation: "add",
      //         values: [
      //           "leftLegResult.finalResult",
      //           "rightLegResult.finalResult",
      //         ],
      //       },
      //     ],
      //   },
      // ],
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "singleLegStance",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
